import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Config, DefaultGameSettings, TwitchStreamer } from "../../types";

interface MetaState {
  loading: boolean;
  error?: string;
  count?: number;
  connectionStatus: ConnectionStatus;

  config?: Config;
  streamers?: TwitchStreamer[];
  settings?: DefaultGameSettings;
}

// In redux/slices/meta.ts
export enum ConnectionStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  RECONNECTING = "reconnecting",
  CONNECTION_ERROR = "connection_error",
  CONNECTION_LOST = "connection_lost",
  CONNECTION_FAILED = "connection_failed",
}

const initialMetaState: MetaState = {
  loading: false,
  error: "",
  connectionStatus: ConnectionStatus.DISCONNECTED,
  streamers: [],
};

const metaSlice = createSlice({
  name: "metaSlice",
  initialState: initialMetaState,
  reducers: {
    updateError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updateCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    updateConnectionStatus: (
      state,
      action: PayloadAction<ConnectionStatus>
    ) => {
      state.connectionStatus = action.payload;
    },
    updateConfig: (state, action: PayloadAction<Config>) => {
      state.config = action.payload;
    },
    updateStreamers: (state, action: PayloadAction<TwitchStreamer[]>) => {
      state.streamers = action.payload;
    },

    updateDefaultGameSettings: (
      state,
      action: PayloadAction<DefaultGameSettings>
    ) => {
      state.settings = action.payload;
    },
  },
});

export const {
  updateConnectionStatus,
  updateError,
  updateLoading,
  updateConfig,
  updateStreamers,
  
  updateCount,
} = metaSlice.actions;
export const metaReducer = metaSlice.reducer;
